// SaaSQuoteStatus.js
import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Button, Heading, Box, Tip } from 'grommet';
import { ShareOption} from 'grommet-icons';
import Iframe from 'react-iframe';


const BPsScreenedComp = () => {
//  const size = useContext(ResponsiveContext);
//  const year = new Date().getFullYear();


  return (
    <Card height="450px" elevation="medium">
      <CardHeader pad={{ horizontal: 'medium', top: 'small', bottom: 'none' }}>
        <Box>
          <Heading margin="none" level={2} pad="none">
            BP's Screens (Qlik- lab)
          </Heading>
        </Box>
      </CardHeader>
      <CardBody pad={{ horizontal: 'medium', top: 'none', bottom: 'small' }} gap="small" align="start" fill>
        <Iframe url="https://erebus.americas.hpqcorp.net/sso/single/?appid=1ec29006-e6e6-407c-8770-745cae97c10e&obj=JQrjsTW&theme=hpewhite&opt=ctxmenu,currsel"
          width="100%" 
          height="100%"
          frameBorder="0"
          overflow="visible"
          allowFullScreen
          scrolling="no"
          id=""
          className=""/>
      </CardBody>
      <CardFooter pad={{horizontal: "small"}} background="light-2">
        <Tip content="Share with colleagues...">
          <Button icon={<ShareOption color="plain" />} 
                  href="mailto:?subject=GT Ops site...&body=https://gt-ops.it.hpe.com"
                  hoverIndicator />
        </Tip>
      </CardFooter>      
    </Card>
  );
};

export { BPsScreenedComp as BPsScreened };
